import { ZERO_COUNT } from "../../reducers/Loader/constants";
import { loading_complete } from "../../reducers/Loader/reducer";

export function set_loading_complete() {
    return (dispatch, getState) => {
        const count = getState().loader?.count;
        const loaded = getState().loader?.loaded;

        if (count - 1 < ZERO_COUNT) {
            throw new Error("set_loading_complete: load count < ZERO_COUNT");
        }

        if (count - 1 === ZERO_COUNT && loaded) {
            throw new Error("set_loading_complete: loaded state already true");
        }

        dispatch(loading_complete());
    };
}
